import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID
} from '@angular/core';
// import { BusinessAccountRequest } from '../../model/account-summary.model';
import { Router } from '@angular/router';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { SwitchingAccountService } from '../../header/switching-account/switching-account.service';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { LogoutService } from '../../services/logout/logout.service';

@Component({
  selector: 'ngc-user-accounts',
  templateUrl: './user-accounts.component.html'
})
export class UserAccountsComponent implements OnInit, OnDestroy {
  @Input() resUserAccountsContent: any;
  @Output() accountSwitch = new EventEmitter();
  @Input() isDelta: any;
  @Input() fromLogin = false; // Checking loading from idp-login
  @Input() corpInfoDetails: any;
  @Output() loginAccountPickerViewSubmit = new EventEmitter();

  accountSummaryServiceSubscribe: Subscription;
  contentHeaderFooterServiceSubscribe: Subscription;
  logOutServiceSubscribe: Subscription;
  businessAccounts: any;
  displayBizAccounts: any;
  loggedInUser: any;
  personalSelected: any;
  currentSwitchedAccount: any;
  businessTypeDisplayed: any;
  public personalAccount: any;
  public businessType: any;
  personalTextForLogin: string;
  businessTravelTextDisplay: string;
  businesschooseAccountDisplayText: string;
  businessChooseAccountDisclaimer: string;
  personalTravelerDisplayText: string;
  learnMoreText: string;
  adminTextDisplay: string;
  corpMembersList: any;
  isBusinessAdmin = false;
  oaSmeAccountCode: any;
  public corpAgreementTypeAndProgramList: any;
  public corpAgreementData: any = [];
  meetingEventTextCode: string;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    public switchingAccountService: SwitchingAccountService,
    private contentService: ContentHeaderFooterService,
    private accountSummaryService: AccountSummaryService,
    private bsModalRef: BsModalRef,
    private elementRef: ElementRef,
    private datalayer: DataLayer,
    private logOutService: LogoutService,
    private appconfig: ApplicationConfig,
    @Inject(DOCUMENT) private document, // L-Pick
    private changeDetection: ChangeDetectorRef,
    private cookieHelper: CookieHelper,
    private router: Router,
    private userSession: UserSessionService,
    private loggingService: LoggingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.oaSmeAccountCode =
      this.appconfig.get('APP_BUSINESS_OA_SME_ACCOUNTS') || null;
    this.corpAgreementTypeAndProgramList =
      this.appconfig.get('APP_CORPORATE_AGREEMENT_TYPE_CODE') || null;
    this.meetingEventTextCode = this.appconfig.get('APP_MEETING_CODE') || null;
  }

  ngOnInit() {
    this.setCorporateCode(this.corpAgreementTypeAndProgramList);

    if (isPlatformBrowser(this.platformId)) {
      if (this.userSession.getServiceWorkerCheck()) {
        this.getAccountDetails();
      }
    }
    this.modalResizeScroll();
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.modalResizeScroll();
    this.setHeightonMobile();
  }

  getAccountDetails() {
    this.accountSummaryServiceSubscribe = this.accountSummaryService
      .getAccountSummaryDetails(this.fromLogin)
      .subscribe(
        (res) => {
          if (res && this.fromLogin) {
            this.datalayer.setDdcfbData(res, true);
          }
          if (res !== null && Object.keys(res).length > 0 && !this.fromLogin) {
            const cookieObject = Object.assign(
              {},
              { hasCookie: this.cookieHelper.getCookies('corp') ? true : false }
            );
            if (this.switchingAccountService.hideBusinessDetails) {
              this.businessAccounts = [];
            } else {
              this.setResponseToBusinessTravel(
                res,
                this.fromLogin,
                this.switchingAccountService.initialBusinessType,
                22
              );
            }
            if (cookieObject.hasCookie) {
              this.setCorpCookieDetailsToBusinessTravel();
            }
            if (this.businessAccounts.length !== 0) {
              this.displayBizAccounts = this.getTrimmedBusinessName(
                this.businessAccounts,
                22
              );
            }
            // TODO: This call will be replaced with API call during page load
            this.accountSummaryService.getCrpAdminList().subscribe(
              (response) => {
                this.corpMembersList = response.memberAgreementList;
                if (this.corpMembersList) {
                  this.addAdministratorItemForAccounts(
                    res,
                    this.switchingAccountService.initialBusinessType,
                    22
                  );
                }
              },
              (err) => {
                this.loggingService.log(
                  'Caught Error - error in admin call : ' + err
                );
              }
            );
            this.setAemDataAndDashBrdResponse(
              res,
              this.switchingAccountService.initialBusinessType
            );
          } else if (this.fromLogin) {
            this.contentHeaderFooterServiceSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      setTimeout(() => {
                        // added timeout to get the updated loggedinFlag information
                        this.businessType = data.header.auxiliaryNavigation.get(
                          'profileSelector'
                        )
                          ? data.header.auxiliaryNavigation.get(
                              'profileSelector'
                            ).details
                          : null;
                        /** this section needs to be checked - start */
                        this.resUserAccountsContent =
                          data.header.auxiliaryNavigation.get('myFlightPanel')
                            ? data.header.auxiliaryNavigation.get(
                                'myFlightPanel'
                              ).details
                            : null;
                        this.isDelta = true;
                        /** this section needs to be checked - end */
                        this.personalAccount =
                          this.businessType['businessTravelerDisplayText'];
                        this.setResponseToBusinessTravel(
                          res,
                          this.fromLogin,
                          this.businessType,
                          25
                        );
                        this.setAemDataAndDashBrdResponse(
                          res,
                          this.businessType
                        );
                        if (this.businessAccounts.length !== 0) {
                          this.displayBizAccounts = this.getTrimmedBusinessName(
                            this.businessAccounts,
                            25
                          );
                        }
                        this.switchingAccountService.setSelectedAccount(
                          this.businessType.personalLoginDisplayText,
                          this.loggedInUser.firstName,
                          false,
                          false,
                          'personal',
                          null,
                          0
                        );
                        // TODO: This call will be replaced with API call during page load
                        this.accountSummaryService.getCrpAdminList().subscribe(
                          (response) => {
                            this.corpMembersList = response.memberAgreementList;
                            if (this.corpMembersList) {
                              this.addAdministratorItemForAccounts(
                                res,
                                this.businessType,
                                25
                              );
                            }
                          },
                          (err) => {
                            this.loggingService.log(
                              'Caught Error - error in admin call : ' + err
                            );
                          }
                        );
                      }, 10);
                    }
                  },
                  (err) => {
                    this.loggedInUser.log('Caught Error: ' + err);
                  }
                );
          }
        },
        (err) => {
          this.loggedInUser.log('Caught Error in Useraccount : ' + err);
        }
      );
    this.personalSelected = !this.switchingAccountService.businessAccount;
    this.setHeightonMobile();
  }

  setHeightonMobile() {
    const docHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
    const modalData = document.getElementsByTagName('modal-container');
    const topAlign = modalData[0]?.querySelector(
      '.modal-body.picker-modal-body'
    );
    const modalContent = modalData[0]?.querySelector(
      '.loggedin-container .modal-content'
    );
    const modalContentLoggeddiv = modalData[0]?.querySelector(
      '.loggedin-modal.loggedin-user-modal'
    );
    if (docHeight && docHeight < 767 && modalData && modalData.length > 0) {
      if (topAlign && modalContent && modalContentLoggeddiv) {
        topAlign.setAttribute('style', 'height:' + (docHeight - 40) + 'px;');
        modalContent.setAttribute('style', 'min-height: auto');
        modalContentLoggeddiv.setAttribute('style', 'min-height: auto');
      }
    } else {
      if (topAlign && modalContent && modalContentLoggeddiv) {
        topAlign.removeAttribute('style');
        modalContent.removeAttribute('style');
        modalContentLoggeddiv.removeAttribute('style');
      }
    }
  }

  setAemDataAndDashBrdResponse(DashBrdresponse: any, aemBusinessType: any) {
    this.loggedInUser = {
      firstName: DashBrdresponse.firstName,
      lastName: DashBrdresponse.lastName
    };
    this.personalTextForLogin = aemBusinessType.personalTravelerDisplayText;
    this.businessTravelTextDisplay =
      aemBusinessType.businessTravelerDisplayText;
    this.businesschooseAccountDisplayText =
      aemBusinessType.chooseAccountDisplayText;
    this.businessChooseAccountDisclaimer =
      aemBusinessType.chooseAccountDisclaimer;
    this.personalTravelerDisplayText =
      aemBusinessType.personalTravelerDisplayText;
    this.learnMoreText = this.dataAvailability(aemBusinessType.learnMoreText);
  }

  dataAvailability(value): string {
    return value && value.length ? value : '';
  }

  setCorpCookieDetailsToBusinessTravel() {
    const checkBusinessName = this.cookieHelper
      .getCookies('corp')
      .split('|')[1]
      .split('=')[1]
      .replace(/#/g, ' ');
    const accountFound = this.businessAccounts
      .map(({ businessName }, index) => {
        if (businessName === checkBusinessName) {
          return index;
        }
      })
      .filter((value) => value !== undefined)[0];
    if (accountFound === undefined) {
      this.businessAccounts.push({
        businessName: checkBusinessName,
        businessType:
          this.switchingAccountService.initialBusinessType
            .businessTravelerDisplayText,
        selected:
          this.switchingAccountService.accountName === checkBusinessName
            ? true
            : false,
        isIntranetLink: true,
        businessCode: 'B:',
        partnerId: 'edp',
        isNuTravelAdmin: false,
        isAdmin: false,
        isOaSmeAccount: false,
        isTripLink: false
      });
    } else {
      this.businessAccounts[accountFound].selected =
        this.switchingAccountService.accountName === checkBusinessName
          ? true
          : false;
      this.businessAccounts[accountFound].partnerId = 'edp';
      this.businessAccounts[accountFound].isIntranetLink = true;
    }
  }

  getTrimmedBusinessName(accounts, charLimit) {
    if (isPlatformBrowser(this.platformId)) {
      accounts.map((account, index) => {
        const bizName = account.businessName;
        if (bizName.length > charLimit) {
          account.trimmedBusinessName = bizName.substring(0, charLimit) + '...';
        } else {
          account.trimmedBusinessName = bizName;
        }
      });
      return accounts;
    }
  }

  setResponseToBusinessTravel(
    res: any,
    isLogin: boolean,
    aemContent: any,
    charLimit: number
  ) {
    if (res && res.crprtAgrmntTypeCode) {
      // added to check SME Users
      const names = res.crprtName.split('|');
      const types = res.crprtAgrmntTypeCode.split('|');
      const corporateAgreementIdList = res.crprtAgrmntId
        ? res.crprtAgrmntId.split('|')
        : '';
      const corporateAgreementIdExists = res.crprtAgrmntId ? true : false;
      const adminLists = res.adminCompanyName
        ? res.adminCompanyName.split('|')
        : '';
      const programTypeList = res.pgmType ? res.pgmType.split('|') : '';
      const contractMgtEnt = res.contractMgtEnt
        ? res.contractMgtEnt.split('|')
        : '';
      const program = res.program ? res.program.split('|') : '';
      const userIdList = res.userId ? res.userId.split('|') : '';
      const acc = names.map((n, idx) => {
        const corpAgreeIdPresent =
          corporateAgreementIdExists &&
          corporateAgreementIdList[idx] &&
          corporateAgreementIdList[idx] !== 'NA'
            ? true
            : false;
        const companyNameDisplay = this.getCompanyNameFromAemForOa(
          n,
          corpAgreeIdPresent,
          aemContent
        );
        const nuTravelAdminDataSet = this.getAdminUrl(
          aemContent,
          types[idx],
          userIdList[idx]
        );
        if (
          adminLists !== '' &&
          adminLists[idx] !== 'NA' &&
          !this.isBusinessAdmin
        ) {
          this.isBusinessAdmin = true;
          this.adminTextDisplay = aemContent.adminLoginDisplayText;
        }
        const tempbusinessAccountList = {
          businessName: companyNameDisplay.companyName,
          businessType: isLogin
            ? aemContent.businessTravelerDisplayText
            : this.switchingAccountService.initialBusinessType
                .businessTravelerDisplayText,
          isTripLink:
            this.corpAgreementData &&
            types[idx] === this.corpAgreementData['concur']
              ? true
              : false,
          partnerId: this.getCorporatePartnerName(
            types[idx],
            corpAgreeIdPresent,
            programTypeList[idx],
            program[idx],
            companyNameDisplay.isOaSME
          ),
          meetingCodeText: this.getAccountType(
            types[idx],
            programTypeList[idx]
          ),
          selected: isLogin
            ? false
            : this.getSelectedAccount(companyNameDisplay.companyName),
          corporateAgreementId: corpAgreeIdPresent
            ? corporateAgreementIdList[idx]
            : '',
          isOaSmeAccount: companyNameDisplay.isOaSME,
          isAdmin: adminLists === '' || adminLists[idx] === 'NA' ? false : true,
          adminBizName: this.getTrimmedBusinessNameForAdmin(
            adminLists[idx],
            charLimit
          ),
          adminLink: nuTravelAdminDataSet.adminLinkUrl,
          isNuTravelAdmin: nuTravelAdminDataSet.isNuTravelAdmin,
          crprtAgrmntTypeCode: types[idx],
          contractMgtEnt: contractMgtEnt[idx],
          program: program[idx],
          businessCode: 'B:',
          isIntranetLink: false
        };
        return tempbusinessAccountList;
      });
      this.businessAccounts = acc;
    } else {
      this.loggedInUser = { firstName: res.firstName, lastName: res.lastName };
      this.businessAccounts = [];
    }
  }

  getTrimmedBusinessNameForAdmin(bizName: any, charLimit: number): any {
    return bizName.length > charLimit
      ? bizName.substring(0, charLimit) + '...'
      : bizName;
  }

  getAdminUrl(
    aemContentForAdmin: any,
    corpAgrmntTypeCode: any,
    userIdVal: any
  ): any {
    const nuTravelAdminData: any = {};
    if (
      this.corpAgreementData &&
      corpAgrmntTypeCode === this.corpAgreementData['nutravel']
    ) {
      nuTravelAdminData.adminLinkUrl = aemContentForAdmin.nuTravelAdminLoginUrl
        ? `${aemContentForAdmin.nuTravelAdminLoginUrl}${userIdVal}`
        : '';
      nuTravelAdminData.isNuTravelAdmin = true;
    } else {
      nuTravelAdminData.adminLinkUrl = aemContentForAdmin.adminLoginUrl
        ? aemContentForAdmin.adminLoginUrl
        : '';
      nuTravelAdminData.isNuTravelAdmin = false;
    }
    return nuTravelAdminData;
  }

  getCorporatePartnerName(
    corporateAgreementTypeCode: any,
    corporateAgreementId: boolean,
    programType: any,
    program: string,
    isOaSme: boolean
  ): any {
    if (this.corpAgreementData) {
      if (
        corporateAgreementTypeCode === this.corpAgreementData['edp'] ||
        corporateAgreementTypeCode === this.corpAgreementData['edpCna']
      ) {
        return 'edp';
      } else if (
        corporateAgreementTypeCode === this.corpAgreementData['concur'] ||
        corporateAgreementTypeCode === this.corpAgreementData['concurold']
      ) {
        return corporateAgreementId ? 'concur-spid' : 'concur-no-spid';
      } else if (
        corporateAgreementTypeCode === this.corpAgreementData['nutravel']
      ) {
        if (programType === this.corpAgreementData['corporateRewards']) {
          return program === 'SKYB' ? 'nutravel-skyb' : 'nutravel-sme';
        } else if (programType === this.corpAgreementData['noprogram']) {
          return 'nutravel-no-program';
        } else {
          return 'nutravel-spid';
        }
      } else if (corporateAgreementTypeCode === this.corpAgreementData['sme']) {
        if (program === 'SKYB') return 'standalone-sky-skyb';
        return isOaSme ? 'standalone-oa-sme' : 'standalone-sky';
      }
    }
    return 'personal';
  }

  getCompanyNameFromAemForOa(
    companyName: any,
    isCorporateAgreementIdPresent: boolean,
    aemContentForBusiness: any
  ): any {
    const companyNameDisplay: any = {};
    companyNameDisplay.companyName = companyName;
    companyNameDisplay.isOaSME = false;
    if (this.oaSmeAccountCode) {
      const companyCodeForOaSmeList = this.oaSmeAccountCode.split(',');
      companyCodeForOaSmeList.forEach((OaSMECompanyCode) => {
        if (companyName === OaSMECompanyCode && isCorporateAgreementIdPresent) {
          companyNameDisplay.companyName = aemContentForBusiness[companyName]
            ? aemContentForBusiness[companyName]
            : '';
          companyNameDisplay.isOaSME = true;
          return companyNameDisplay;
        }
      });
    }
    return companyNameDisplay;
  }

  getSelectedAccount(companyName: any): boolean {
    if (
      this.switchingAccountService.businessAccount &&
      companyName === this.switchingAccountService.accountName
    ) {
      return true;
    }
    return false;
  }

  addAdministratorItemForAccounts(res, getBusinessType, charLimit) {
    // code added for fetching administrator related information
    const ids = res.crprtAgrmntId.split('|');
    const names = res.crprtName.split('|');
    // const adminList = [];
    this.adminTextDisplay = getBusinessType.adminLoginDisplayText;
    const adminIds = this.corpMembersList.map(({ id }) => id);
    if (ids && this.businessAccounts) {
      ids.map((id, index) => {
        if (adminIds.indexOf(id) > -1) {
          this.businessAccounts.map((account) => {
            if (account.businessName === names[index]) {
              this.isBusinessAdmin = true;
              const bizName = account.businessName;
              account['isAdmin'] = true;
              account['adminBizName'] =
                bizName.length > charLimit
                  ? bizName.substring(0, charLimit) + '...'
                  : bizName;
              account['adminLink'] = getBusinessType.adminLoginUrl;
            }
            return account;
          });
        }
      });
    }
  }

  selectePersonalAccount() {
    const partnerIdForPersonal = this.getCorporatePartnerName(
      '',
      false,
      '',
      '',
      false
    );
    if (this.fromLogin) {
      this.switchingAccountService.setSelectedAccount(
        this.businessType.personalLoginDisplayText,
        this.loggedInUser.firstName,
        false,
        false,
        partnerIdForPersonal,
        null,
        0
      );
    } else {
      this.switchingAccountService.setSelectedAccount(
        this.switchingAccountService.initialBusinessType
          .personalLoginDisplayText,
        this.loggedInUser.firstName,
        false,
        false,
        partnerIdForPersonal,
        null,
        0
      );
    }
    this.switchingAccountService.toggleAccount(false, false);
    this.personalSelected = true;
    this.accountSwitch.emit();
    if (this.businessAccounts) {
      this.businessAccounts.map((businessAccount) => {
        if (businessAccount.selected) {
          businessAccount.selected = false;
        }
      });
    }
    this.accountSummaryService.postAccountType('P').subscribe(
      (resp) => {
        if (this.fromLogin) {
          this.loginAccountPickerViewSubmit.emit();
        }
      },
      (error) => {
        this.loggingService.log('Caught Error in postAccountType : ' + error);
      }
    );
    setTimeout(() => {
      this.switchingAccountService.hideSwitching();
    }, 2000);
  }

  selectPersonalOnEnter(evt) {
    if (evt.keyCode === 13) {
      this.selectePersonalAccount();
    }
  }

  selectAccount(evt, account, fromAdmin) {
    this.personalSelected = false;
    const checkSelectedCompanyValue =
      this.switchingAccountService.getUserInfo();
    this.businessAccounts.map((businessAccount, index) => {
      if (businessAccount.selected) {
        businessAccount.selected = false;
      }
      if (businessAccount.businessName === account.businessName) {
        const business = businessAccount.businessCode + index;
        if (
          checkSelectedCompanyValue.selectedCompany !== account.businessName
        ) {
          this.switchingAccountService.showSwitching();
          if (this.fromLogin) {
            this.switchingAccountService.setSelectedAccount(
              this.businessType.businessLoginDisplayText,
              businessAccount.businessName,
              true,
              businessAccount.isOaSmeAccount,
              businessAccount.partnerId,
              businessAccount,
              index
            );
          } else {
            this.switchingAccountService.setSelectedAccount(
              this.switchingAccountService.initialBusinessType
                .businessLoginDisplayText,
              businessAccount.businessName,
              true,
              businessAccount.isOaSmeAccount,
              businessAccount.partnerId,
              businessAccount,
              index
            );
          }
          this.switchingAccountService.toggleAccount(true, false);
        }
        this.accountSwitch.emit();
        businessAccount.selected = true;
        this.accountSummaryService.postAccountType(business).subscribe(
          (resp) => {
            if (fromAdmin) {
              const targetVal = account.isNuTravelAdmin ? '_self' : '_blank';
              window.open(account.adminLink, targetVal);
              if (this.fromLogin && !account.isNuTravelAdmin) {
                this.loginAccountPickerViewSubmit.emit();
              }
            } else if (this.fromLogin) {
              this.loginAccountPickerViewSubmit.emit();
            }
          },
          (error) => {
            this.loggingService.log(
              'Caught Error in postAccountType : ' + error
            );
          }
        );
      }
    });
    setTimeout(() => {
      this.switchingAccountService.hideSwitching();
      //  if (this.personalSelected) {
      // }
    }, 2000);
  }

  selectBusinessOnEnter(evt, account) {
    if (evt.keyCode === 13) {
      this.selectAccount(evt, account, false);
    }
  }

  selectAdminOnEnter(evt, account) {
    if (evt.keyCode === 13) {
      this.selectAdmin(evt, account);
    }
  }

  selectAdmin(evt, account) {
    if (!this.fromLogin) {
      this.bsModalRef.hide();
    }
    this.selectAccount(evt, account, true);
  }

  getAccountType(corporateAgreementCode: string, programType: string) {
    let textCode = '';
    if (this.meetingEventTextCode) {
      const type = this.meetingEventTextCode.split(',');
      type.forEach((dataVal) => {
        if (dataVal === programType) {
          textCode = programType;
        }
        if (dataVal === corporateAgreementCode) {
          textCode = corporateAgreementCode;
        }
      });
    }
    return textCode;
  }

  removeCookieAndLogout(logoutUrl) {
    if (isPlatformBrowser(this.platformId) && document) {
      this.logOutServiceSubscribe = this.logOutService
        .logOutAction(logoutUrl)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            this.logOutService.pingLogOut();
          },
          (err) => {
            window.location.replace('/');
            this.loggingService.log('Caught Error: ' + err);
          }
        );
    }
  }

  modalResizeScroll() {
    const docHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
    const modalData = document.getElementsByTagName('modal-container');
    if (docHeight && docHeight < 640 && modalData && modalData.length > 0) {
      modalData[0].classList.add('height-scroll');
    }
  }

  setCorporateCode(agreementTypeList) {
    this.corpAgreementTypeAndProgramList = agreementTypeList
      ? agreementTypeList
      : this.corpAgreementTypeAndProgramList;
    if (this.corpAgreementTypeAndProgramList) {
      const corpList = this.corpAgreementTypeAndProgramList.split(',');
      corpList.forEach((corpAgreementKey) => {
        const tempKey = corpAgreementKey.split(':')[0];
        const tempVal = corpAgreementKey.split(':')[1];
        this.corpAgreementData[tempKey] = tempVal;
      });
    } else {
      this.corpAgreementData = null;
    }
  }

  ngOnDestroy() {
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.logOutServiceSubscribe) {
      this.logOutServiceSubscribe.unsubscribe();
    }
  }

  closeAdmin() {
    if (!this.fromLogin) {
      this.bsModalRef.hide();
    }
  }
}
